@use '~/theme/theme' as *;
@use '~/theme/typography';

.combobox {
  display: flex;
  align-items: center;
  height: 100%;
  width: 0;
  min-width: 100%;
  overflow: hidden;

  &[data-read-only='true'] {
    color: color(grey-500);
  }

  .input {
    flex: 1 0 0;
    width: auto;
    min-width: 0;
    display: flex;
    padding: 0;
    margin: 0 1px;
    text-indent: spacing(1);
  }
}

.button {
  appearance: none;
  border: none;
  background: none;
  margin: 0;
  cursor: pointer;
  display: flex;
  min-width: 0;
  padding: 0 spacing(1);
  width: 100%;
  height: 100%;
  gap: spacing(1);
}

.buttonContent {
  width: 100%;
  padding: spacing(1) 0;
}

.accountDetails {
  overflow: hidden;
}

.skeleton {
  width: 100%;
  height: 100%;
  margin-right: spacing(1);
  border-radius: 6px;
  z-index: -1;
}

.skeletonSubfield {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: spacing(0.5);
  padding: spacing(0.5);
  height: 100%;
  justify-content: center;
}

.code {
  color: color(grey-600);
  font-family: 'Public Sans', sans-serif;
}

.chevron {
  flex-shrink: 0;
}

.searchField {
  margin: spacing(2) spacing(1.5);

  input:focus {
    outline: none;
  }
}
